<template>
  <el-dialog
    title="添加套餐"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true" 
    width="70%"
  >
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="套餐名称">
          <el-input placeholder="请输入套餐名称" v-model="formInline.search">
           
          </el-input>
        </el-form-item>




        <el-form-item>

            <el-button type="primary"  icon="el-icon-search" @click="getData">查询</el-button>
            <el-button  icon="el-icon-search" @click="reast">重置</el-button>
    
        </el-form-item>

      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加套餐</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="equip_package_id" label="ID"></el-table-column>
            <el-table-column prop="name" label="套餐名称"></el-table-column>

            <el-table-column prop="avatarUrl" label="设备封面">
            <template slot-scope="scope">
              <div v-if="scope.row.cover">
                <img :src="scope.row.cover" width="60px" height="60px"
              
                />
              </div>
            </template>
          </el-table-column>  

            <el-table-column prop="money" label="金额"></el-table-column>
            <el-table-column prop="minute" label="时间/分钟"></el-table-column>
            <!-- <el-table-column prop="min_minute" label="可申请退款时间">
              <template slot-scope="scope">
                <div>小于等于{{ scope.row.min_minute }}分钟</div>
              </template>

            </el-table-column> -->

            <el-table-column prop="time" label="状态">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ff4949" @change="isDefaultChange(scope.row)"></el-switch>

              </template>
            </el-table-column>


            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column prop="update_time" label="修改时间" width="150"></el-table-column>

            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add" :equip_id="equip_id"   @close="closeAdd"></Add>
    <Edit :open_edit="open_edit" :equip_package_id="equip_package_id"  v-if="open_edit"   @close="closeEdit"></Edit>
  
  </div>
  </el-dialog>
</template>

<script>
  import EquipApi from '@/api/equip.js';
  import Add from './add.vue';
  import Edit from './edit.vue';
  export default {
    components: {
      Add,
      Edit
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          search:"",
          sales:"",
          status:-1,
          address:"",
          create_time:""
        },

        open_add:false,
        open_edit:false,

        dialogVisible:false
      };
    },
    created() {
      console.log("111111")
      this.dialogVisible = this.open_package_add;
      /*获取列表*/
      this.getTableList();
    },
    props: ["open_package_add",'equip_id'],
    methods: {
      isDefaultChange(row) {
      let self = this
      self.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let status = 1;
        if(row.status){
          status = 1;
        }else{
          status = 0;
        }
        self.loading = true;
        EquipApi.setPackageStatus({status:status,equip_package_id:row.equip_package_id}, true).then(data => {
          console.log(data)
          if (data.code === 1) {
            self.loading = false;
            self.$message({
              message: '恭喜你，操作成功',
              type: 'success'
            });
            self.getTableList();
          } else {
            self.loading = false;
          }
        }).catch(error => {
          self.loading = false;
        });
      }).catch(() => {
        row.is_default = !row.is_default
      })
    },

      reast(){
        this.formInline = {
          search:"",
          sales:"",
          status:-1,
          address:""
        };
        this.getTableList();
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
       /*关闭弹窗*/
       dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":result });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        Params.equip_id = self.equip_id
        EquipApi.package(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
            for(var i=0;i<self.tableData.length;i++){
              self.tableData[i].status = self.tableData[i].status==1?true:false;
            }
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },
      detailClick(row){
        let self = this;
      let params = row.equip_id;
      self.$router.push({
        path: '/plus/equip/equip/part/detail',
        query: {
          equip_id: params
        }
      });
      },
      /*编辑活动*/
      editClick(row) {
        this.equip_package_id = row.equip_package_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            EquipApi.del_package(
              {
                equip_package_id: row.equip_package_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/equip/equip/part/package/index.vue